import { GenericObject, copyFields } from '@synergy/models';

export class Price {
    public currency!: string;
    public value!: number;
    public minimumQuantity!: number;

    public static fromPlainObject(object: GenericObject): Price {
        const price = new Price();

        copyFields(object, price);

        return price;
    }
}
